import { action, observable, makeObservable } from 'mobx';
import { dataManagerFactory, configurationsStore } from 'utils/MobxDataManager/singletons';

export class JobStore {
    private readonly masterAccountId: string;
    @observable jobsList: Nullable<IJobSummary[]>;

    @observable isLoadingJobs: boolean;

    @observable selectedJobId: string | number;

    @observable selectedJobCode: string;

    @observable jobDetails: Nullable<JobDetails>;

    @observable jobLocations: JobLocation[];

    @observable isLoadingJobDetails: boolean;

    constructor(masterAccountId: string) {
        makeObservable(this);
        this.masterAccountId = masterAccountId;
        this.jobsList = null;
        this.isLoadingJobs = false;
        this.selectedJobId = '';
        this.selectedJobCode = '';
        this.jobDetails = null;
        this.jobLocations = [];
        this.isLoadingJobDetails = false;
    }

    @action
    async fetchJobs(): Promise<void> {
        if (this.isLoadingJobs || !!this.jobsList) {
            return;
        }

        this.isLoadingJobs = true;
        const jobs = await dataManagerFactory.getJobDataManager().getJobsUnderManager(this.masterAccountId);
        this.jobsList = jobs ?? [];
        this.isLoadingJobs = false;
    }

    @action
    async fetchJobDetails(): Promise<void> {
        if (this.selectedJobId !== this.jobDetails?.orgJobId) {
            this.jobDetails = null;
        }

        this.isLoadingJobDetails = true;
        this.jobDetails = await dataManagerFactory.getJobDataManager().getJobDetails(
            this.masterAccountId,
            this.selectedJobId);
        this.isLoadingJobDetails = false;
    }

    @action
    async fetchJobLocations(): Promise<void> {
        this.jobLocations = await dataManagerFactory.getJobDataManager().getJobLocations(
            this.masterAccountId,
            this.selectedJobCode
        ) || [];
    }

    @action
    clearJobDetails(): void {
        this.jobDetails = null;
    }

    @action
    setSelectedJobId(id: string | number): void {
        this.selectedJobId = id;
    }

    @action
    setSelectedJobCode(jobCode: string): void {
        this.selectedJobCode = jobCode;
    }

    formatRangeValue(value: number, currency?: string): string {
        return configurationsStore.currentConvertedConfiguration.format.formatCurrencyValue(
            currency || 'USD',
            value,
            false);
    }
}